import React, { useState, useEffect, useRef } from 'react';
import { SOCIAL_MEDIA } from '../../constant/constant';
import './SocialMediaLinksEnhanced.css';
import { useTranslation } from 'react-i18next';

interface SocialMediaItemProps {
  socialMedia: typeof SOCIAL_MEDIA[0];
  index: number;
}

const SocialMediaItem: React.FC<SocialMediaItemProps> = ({ socialMedia, index }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, index * 150); // Staggered animation
        }
      },
      { threshold: 0.1 }
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, [index]);

  const handleClick = () => {
    // Check if it's a mobile device
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Open the appropriate URL based on device
    if (isMobile && socialMedia.mobileUrl) {
      window.location.href = socialMedia.mobileUrl;
    } else {
      window.open(socialMedia.webURl, '_blank');
    }
  };

  return (
    <div 
      ref={itemRef}
      className={`social-media-item-enhanced ${isVisible ? 'visible' : ''} ${isHovered ? 'hovered' : ''} ${socialMedia.style}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className="social-media-icon-wrapper">
        <div className="social-media-icon-container-enhanced">
          <img 
            src={socialMedia.icon} 
            alt={socialMedia.id} 
            className="social-media-icon-enhanced"
          />
        </div>
        <div className="social-media-pulse"></div>
      </div>
      
      <div className="social-media-info-enhanced">
        <h3 className="social-media-name-enhanced">{socialMedia.id}</h3>
        {/* <p className="social-media-link-enhanced">{socialMedia.webURl}</p> */}
        <div className="social-media-cta">
          <span className="social-media-cta-text">Follow Us</span>
          <span className="social-media-cta-arrow">→</span>
        </div>
      </div>
      
      <div className="social-media-background"></div>
    </div>
  );
};

const SocialMediaLinksEnhanced: React.FC = () => {
  const { t: translate } = useTranslation();
  return (
    <div className="social-media-container-enhanced">
      <div className="social-media-header">
        <h1 className="social-media-title-enhanced quick-overview-title">{translate('connectUs')}</h1>
        <div className="social-media-title-underline"></div>
        <p className="social-media-subtitle-enhanced">
          Follow us on social media for updates, tutorials, and more content
        </p>
      </div>
      
      <div className="social-media-links-enhanced">
        {SOCIAL_MEDIA.map((socialMedia, index) => (
          <SocialMediaItem 
            key={socialMedia.id} 
            socialMedia={socialMedia} 
            index={index} 
          />
        ))}
      </div>
    </div>
  );
};

export default SocialMediaLinksEnhanced;
